import {  useEffect, useMemo, useRef, useState } from "react";
import { useAppSelector } from "../../../../hooks/store-hooks";
import { IClienteTable, ILimitacaoConsumoTable, IPerfil, ITipoUsuario, IUsuario } from "../../../../../application/models";
import { useLimitacaoConsumoService } from "../../../../../use-cases/limitacao-consumo";
import { useClientesService } from "../../../../../use-cases/clientes";
import { Accordion, AccordionSummary, AccordionDetails, Autocomplete, Box, Button, Chip, darken, debounce, Dialog, DialogContent, DialogTitle, DialogActions, Divider, Grid, IconButton, lighten, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, styled, TextField, Tooltip, Typography } from "@mui/material";
import { MaterialReactTable, MRT_ColumnDef, useMaterialReactTable } from "material-react-table";
import { format } from "date-fns";
import { MRT_Localization_PT_BR } from "material-react-table/locales/pt-BR";
import { SkeletonVelesTable, ModalTiposConsumo } from "../../../../components";
import AddIcon from '@mui/icons-material/Add'
import EditIcon from '@mui/icons-material/Edit'
import VisibilityIcon from "@mui/icons-material/Visibility";
import SearchIcon from '@mui/icons-material/Search';
import LayersIcon from '@mui/icons-material/Layers';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { buildClienteTextSearchFiltersFromTerm } from '../../../../../utils/cliente-busca-unificada';


export const ListaTravaConsumo = () => {
    // State
    const { currentUser } = useAppSelector((state: any) => state.user);
    const {
        limitacaoConsumoList,
        limitacaoConsumoTotal,
        clienteSelecionado,
        usuarios,
        usuarioSelecionado,
        perfis,
        perfilSelecionado,
        limitacaoConsumoPagination
    } = useAppSelector((state: any) => state.limitacaoConsumo)
    const { clientes } = useAppSelector((state: any) => state.clientes)
    // Use State
    const [loading, setLoading] = useState(true)
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 5
    })
    const [openCreateOptions, setOpenCreateOptions] = useState<boolean>(false)
    const [buscaRealizada, setBuscaRealizada] = useState<{
        tipo: 'cliente' | 'perfil' | 'usuario';
        nome: string;
    } | null>(null)
    const [selectedGroup, setSelectedGroup] = useState<ILimitacaoConsumoTable | null>(null)
    // Useful variables
    const lastFetchedClienteIdRef = useRef<number | null>(null);
    const isDemais = currentUser?.IdVelesPerfilInterno === ITipoUsuario.USUARIO_VELES_DEMAIS
    const isTecnologiaDaInformacao = currentUser?.IdVelesPerfilInterno === ITipoUsuario.TECNOLOGIA_DA_INFORMACAO
    const isCliente = currentUser?.IdVelesPerfilInterno === ITipoUsuario.USUARIO_CLIENTE

    const canEdit = isDemais || isTecnologiaDaInformacao || isCliente
    const canCreate = isDemais || isTecnologiaDaInformacao || isCliente
    // Service
    const {
        setClienteSelecionado,
        findUsuarios,
        findPerfis,
        findLimitacaoConsumoCliente,
        findLimitacaoConsumoUsuario,
        findLimitacaoConsumoPerfil,
        resetClienteSelecionado,
        setLimitacaoConsumoPagination,
        setCreateLimitacaoConsumoClienteOpenForm,
        setUpdateLimitacaoConsumoClienteOpenForm,
        setUpdateLimitacaoConsumoUsuarioOpenForm,
        setUpdateLimitacaoConsumoPerfilOpenForm,
        setCreateLimitacaoConsumoUsuarioOpenForm,
        setCreateLimitacaoConsumoPerfilOpenForm,
        setUsuarioSelecionado,
        resetUsuarioSelecionado,
        setPerfilSelecionado,
        resetPerfilSelecionado,
        resetLimitacaoConsumoList,
        resetLimitacaoConsumoTotal,
        resetCreateLimitacaoConsumoClienteForm,
        resetCreateLimitacaoConsumoUsuarioForm
    } = useLimitacaoConsumoService()
    const { setClientes, setClientesPagination, resetClientesList } = useClientesService()
    useEffect(() => {
        resetClienteSelecionado()
        resetUsuarioSelecionado()
        resetPerfilSelecionado()
        resetLimitacaoConsumoList()
        resetLimitacaoConsumoTotal()
        resetClientesList()
        setBuscaRealizada(null)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // Ao sair da tela, limpar state para voltar "zerado"
    useEffect(() => {
        return () => {
            resetClienteSelecionado()
            resetUsuarioSelecionado()
            resetPerfilSelecionado()
            resetLimitacaoConsumoList()
            resetLimitacaoConsumoTotal()
            setBuscaRealizada(null)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        resetClienteSelecionado()
        resetUsuarioSelecionado()
        resetPerfilSelecionado()
        resetLimitacaoConsumoList()
        resetLimitacaoConsumoTotal()
        resetClientesList()
        setBuscaRealizada(null)
    }, [currentUser, resetClienteSelecionado, resetUsuarioSelecionado, resetPerfilSelecionado, resetLimitacaoConsumoList, resetLimitacaoConsumoTotal, resetClientesList])

    useEffect(() => {
        setClientesPagination({
            limit: 50,
            page: 1
        })

        if (currentUser) {
            if (currentUser.IdVelesPerfilInterno === ITipoUsuario.USUARIO_VELES_COMERCIAL) {
                setClientes({
                    SearchCNPJ: '',
                    SearchRazaoSocial: '',
                    SearchNomeFantasia: '',
                    SearchLoginCliente: '',
                    SearchInclusaoMaxima: undefined,
                    SearchInclusaoMinima: undefined,
                    SearchIdUsuario: currentUser.IdUsuario,
                    searchIdVendedor: currentUser.IdUsuario,
                    SearchIdCliente: currentUser.IdCliente
                });
            } else if (currentUser.IdVelesPerfilInterno === ITipoUsuario.USUARIO_VELES_DEMAIS ||
                currentUser.IdVelesPerfilInterno === ITipoUsuario.TECNOLOGIA_DA_INFORMACAO) {
                setClientes({
                    SearchCNPJ: '',
                    SearchRazaoSocial: '',
                    SearchNomeFantasia: '',
                    SearchLoginCliente: '',
                    SearchInclusaoMaxima: undefined,
                    SearchInclusaoMinima: undefined,
                    SearchIdUsuario: currentUser.IdUsuario,
                    searchIdVendedor: 0,
                    SearchIdCliente: 0
                });
            } else if (currentUser.IdVelesPerfilInterno === ITipoUsuario.VELES_SUPERVISOR_COMERCIAL) {
                setClientes({
                    SearchCNPJ: '',
                    SearchRazaoSocial: '',
                    SearchNomeFantasia: '',
                    SearchLoginCliente: '',
                    SearchInclusaoMaxima: undefined,
                    SearchInclusaoMinima: undefined,
                    SearchIdUsuario: currentUser.IdUsuario,
                    searchIdVendedor: 0,
                    SearchIdCliente: 0
                });
            } else if (currentUser.IdVelesPerfilInterno === ITipoUsuario.USUARIO_VELES_EXPERIENCIA_DO_CLIENTE) {
                setClientes({
                    SearchCNPJ: '',
                    SearchRazaoSocial: '',
                    SearchNomeFantasia: '',
                    SearchLoginCliente: '',
                    SearchInclusaoMaxima: undefined,
                    SearchInclusaoMinima: undefined,
                    SearchIdUsuario: currentUser.IdUsuario,
                    searchIdVendedor: 0,
                    SearchIdCliente: 0
                });
            } else if (currentUser.IdVelesPerfilInterno === ITipoUsuario.USUARIO_CLIENTE) {
                setClientes({
                    SearchCNPJ: '',
                    SearchRazaoSocial: '',
                    SearchNomeFantasia: '',
                    SearchLoginCliente: '',
                    SearchInclusaoMaxima: undefined,
                    SearchInclusaoMinima: undefined,
                    SearchIdUsuario: currentUser.IdUsuario,
                    searchIdVendedor: 0,
                    SearchIdCliente: currentUser.IdCliente
                });
            }
        }
    }, [setClientes, currentUser, setClientesPagination]);

    useEffect(() => {
        if (!clienteSelecionado) {
            lastFetchedClienteIdRef.current = null;
            return;
        }
        const idCliente = clienteSelecionado.IdCliente;
        if (lastFetchedClienteIdRef.current === idCliente) return;
        lastFetchedClienteIdRef.current = idCliente;
        findUsuarios();
        findPerfis();
    }, [findUsuarios, findPerfis, clienteSelecionado]);

    // Functions
    const debounceSearchTerm = useMemo(
        () => debounce((searchTerm: string) => {
            if (currentUser) {
                const termoBusca = searchTerm?.trim() || ''
                const textFilters = buildClienteTextSearchFiltersFromTerm(termoBusca)

                const baseParams = {
                    ...textFilters,
                    SearchInclusaoMaxima: undefined,
                    SearchInclusaoMinima: undefined,
                    SearchIdUsuario: currentUser.IdUsuario
                }

                if (currentUser.IdVelesPerfilInterno === ITipoUsuario.USUARIO_VELES_COMERCIAL) {
                    setClientes({
                        ...baseParams,
                        searchIdVendedor: currentUser.IdUsuario,
                        SearchIdCliente: currentUser.IdCliente
                    })
                } else if (currentUser.IdVelesPerfilInterno === ITipoUsuario.USUARIO_VELES_DEMAIS ||
                    currentUser.IdVelesPerfilInterno === ITipoUsuario.TECNOLOGIA_DA_INFORMACAO) {
                    setClientes({
                        ...baseParams,
                        searchIdVendedor: 0,
                        SearchIdCliente: 0
                    })
                } else if (currentUser.IdVelesPerfilInterno === ITipoUsuario.VELES_SUPERVISOR_COMERCIAL) {
                    setClientes({
                        ...baseParams,
                        searchIdVendedor: 0,
                        SearchIdCliente: 0
                    })
                } else if (currentUser.IdVelesPerfilInterno === ITipoUsuario.USUARIO_VELES_EXPERIENCIA_DO_CLIENTE) {
                    setClientes({
                        ...baseParams,
                        searchIdVendedor: 0,
                        SearchIdCliente: 0
                    })
                } else if (currentUser.IdVelesPerfilInterno === ITipoUsuario.USUARIO_CLIENTE) {
                    setClientes({
                        ...baseParams,
                        searchIdVendedor: 0,
                        SearchIdCliente: currentUser.IdCliente
                    })
                }
            }
        }, 700),
        [currentUser, setClientes]
    )

    const sortedClientes = useMemo(() => {
        return [...clientes].sort((a, b) => {
            const firstLetterA = (a.LoginCliente?.[0] || '').toUpperCase()
            const firstLetterB = (b.LoginCliente?.[0] || '').toUpperCase()
            if (firstLetterA !== firstLetterB) {
                return firstLetterA.localeCompare(firstLetterB)
            }
            return (a.LoginCliente || '').localeCompare(b.LoginCliente || '')
        })
    }, [clientes])

    const clienteSelecionadoValido = useMemo(() => {
        if (!clienteSelecionado) return null

        if (isCliente) {
            if (clienteSelecionado.IdCliente !== currentUser?.IdCliente) {
                return null
            }
        }

        if (clientes.length > 0) {
            const clienteEncontrado = clientes.find((c: any) => c.IdCliente === clienteSelecionado.IdCliente)
            if (!clienteEncontrado) {
                return null
            }
            return clienteEncontrado
        }

        const clienteEncontrado = clientes.find((c: any) => c.IdCliente === clienteSelecionado.IdCliente)
        return clienteEncontrado || null
    }, [clienteSelecionado, clientes, isCliente, currentUser])

    const GroupHeader = styled('div')(({ theme }) => ({
        position: 'sticky',
        top: '-8px',
        padding: '4px 10px',
        color: theme.palette.primary.main,
        backgroundColor:
            theme.palette.mode === 'light'
                ? lighten(theme.palette.primary.light, 0.85)
                : darken(theme.palette.primary.main, 0.8),
    }));

    const GroupItems = styled('ul')({
        padding: 0,
    });

    const columns = useMemo<MRT_ColumnDef<ILimitacaoConsumoTable>[]>(() => {
        const columnsToSet: MRT_ColumnDef<ILimitacaoConsumoTable>[] = [
            {
                header: canEdit ? 'Editar' : 'Visualizar',
                size: 50,
                Cell: ({ row }) => (
                        <IconButton
                            color="primary"
                            size="small"
                            onClick={() => {
                                if (usuarioSelecionado) {
                                    setUpdateLimitacaoConsumoUsuarioOpenForm({
                                        open: true,
                                        ativo: row.original.Ativo,
                                        idLimitacaoConsumoUsuario: row.original.IdLimitacaoConsumo,
                                        quantidade: row.original.Quantidade,
                                        idUsuario: usuarioSelecionado.IdUsuario,
                                        idGrupoTrava: row.original.IdGrupoTrava
                                    })
                                } else if (perfilSelecionado) {
                                    setUpdateLimitacaoConsumoPerfilOpenForm({
                                        open: true,
                                        ativo: row.original.Ativo,
                                        idLimitacaoConsumoPerfil: row.original.IdLimitacaoConsumo,
                                        idPerfil: perfilSelecionado.IdPerfil,
                                        quantidade: row.original.Quantidade,
                                        idGrupoTrava: row.original.IdGrupoTrava
                                    })
                                } else {
                                    setUpdateLimitacaoConsumoClienteOpenForm({
                                        open: true,
                                        ativo: row.original.Ativo,
                                        idLimitacaoConsumoCliente: row.original.IdLimitacaoConsumo,
                                        quantidade: row.original.Quantidade,
                                        idCliente: row.original.IdCliente,
                                        idGrupoTrava: row.original.IdGrupoTrava
                                    })
                                }
                            }}
                        >
                        {
                            canEdit ? <EditIcon />
                                : <VisibilityIcon />
                        }
                        </IconButton>
                ),
                muiTableHeadCellProps: {
                    align: 'center',
                },
                muiTableBodyCellProps: {
                    align: 'center',
                },
            },
            {
                header: 'Produto',
                size: 150,
                accessorFn: (row) => {
                    if (row.IdProduto != null) {
                        return row.DescricaoProduto ?? row.Descricao ?? ''
                    }
                    if (row.IdTipoConsumo != null) {
                        return row.DescricaoProduto ?? ''
                    }
                    return ''
                },
                muiTableHeadCellProps: {
                    align: 'center',
                },
                muiTableBodyCellProps: {
                    align: 'center',
                },
            },
            {
                header: 'Variável',
                size: 180,
                accessorFn: (row) => {
                    if (row.subRows?.length) {
                        const count = row.subRows.length
                        return `Grupo (${count} ${count === 1 ? 'tipo' : 'tipos'})`
                    }
                    return row.IdTipoConsumo != null ? row.Descricao : ''
                },
                Cell: ({ row }) => {
                    if (row.original.subRows?.length) {
                        const count = row.original.subRows.length
                        const subRowsNames = row.original.subRows.map(s => s.Descricao).join(', ')
                        const tooltipText = `Grupo Compartilhado (${count} variáveis):\n${subRowsNames}`

                        return (
                            <Tooltip title={<Typography variant="caption" style={{ whiteSpace: 'pre-line' }}>{tooltipText}</Typography>} arrow placement="top">
                                <Chip
                                    icon={<LayersIcon style={{ fontSize: '0.9rem', color: 'inherit' }} />}
                                    label={`GRUPO (${count} ${count === 1 ? 'tipo' : 'tipos'})`}
                                    color="primary"
                                    size="small"
                                    clickable
                                    onClick={() => setSelectedGroup(row.original)}
                                    sx={{
                                        fontWeight: 'bold',
                                        fontSize: '0.72rem',
                                        px: 0.5,
                                        boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
                                        '&:hover': {
                                            transform: 'scale(1.03)',
                                            transition: 'transform 0.15s ease-in-out'
                                        }
                                    }}
                                />
                            </Tooltip>
                        )
                    }
                    return <span>{row.original.IdTipoConsumo != null ? row.original.Descricao : ''}</span>
                },
                muiTableHeadCellProps: {
                    align: 'center',
                },
                muiTableBodyCellProps: {
                    align: 'center',
                },
            },
            {
                accessorKey: 'Quantidade',
                header: 'Quantidade',
                size: 200,
                muiTableHeadCellProps: {
                    align: 'center',
                },
                muiTableBodyCellProps: {
                    align: 'center',
                },
                accessorFn: (rowData: any) => {
                    return rowData.Quantidade
                },
                Cell: ({ cell }) => (
                    <span>{Number(cell.getValue<number>()).toLocaleString('pt-BR')}</span>
                )
            },
            {
                accessorKey: 'Inclusao',
                header: 'Data de Inclusão',
                size: 150,
                accessorFn: (rowData: any) => {
                    if (!rowData?.Inclusao) return null
                    const d = new Date(rowData.Inclusao)
                    return Number.isNaN(d.getTime()) ? null : d
                },
                Cell: ({ cell }) => {
                    const value = cell.getValue<Date | null>()
                    if (!value) return null
                    return <span>{format(value, 'dd/MM/yyyy')}</span>
                },
                muiTableHeadCellProps: {
                    align: 'center',
                },
                muiTableBodyCellProps: {
                    align: 'center',
                }
            },
            {
                accessorKey: 'Atualizacao',
                header: 'Data de Atualização',
                size: 150,
                accessorFn: (rowData: any) => {
                    if (!rowData?.Atualizacao) return null
                    const d = new Date(rowData.Atualizacao)
                    return Number.isNaN(d.getTime()) ? null : d
                },
                Cell: ({ cell }) => {
                    const value = cell.getValue<Date | null>()
                    if (!value) return null
                    return <span>{format(value, 'dd/MM/yyyy')}</span>
                },
                muiTableHeadCellProps: {
                    align: 'center',
                },
                muiTableBodyCellProps: {
                    align: 'center',
                },
            },
            {
                accessorKey: 'Ativo',
                header: 'Status',
                size: 100,
                accessorFn: (rowData: any) => {
                    return rowData.Ativo ? 'Ativo' : 'Inativo';
                },
                Cell: ({ cell }) => {
                    const isActive = cell.getValue<string>() === 'Ativo'

                    return (
                        <Typography
                            color="Background"
                            variant='caption'
                            style={{
                                display: 'inline-block',
                                padding: '4px 8px',
                                borderRadius: '8px',
                                fontWeight: 'bold',
                                backgroundColor: isActive ? 'green' : 'red',
                                textAlign: 'center'
                            }}
                        >
                            {isActive ? 'Ativo' : 'Inativo'}
                        </Typography>
                    )
                }
            }
        ]

        return columnsToSet
    }, [canEdit, perfilSelecionado, setUpdateLimitacaoConsumoClienteOpenForm, setUpdateLimitacaoConsumoPerfilOpenForm, setUpdateLimitacaoConsumoUsuarioOpenForm, usuarioSelecionado]);

    const table = useMaterialReactTable({
        columns,
        data: limitacaoConsumoList,
        enableHiding: false,
        enableFullScreenToggle: false,
        enableGlobalFilter: false,
        enableColumnFilters: false,
        enableExpandAll: false,
        enableDensityToggle: false,
        enableExpanding: true,
        getSubRows: (row) => row.subRows,
        displayColumnDefOptions: {
            'mrt-row-expand': {
                muiTableHeadCellProps: {
                    sx: {
                        display: 'none',
                    },
                },
                muiTableBodyCellProps: {
                    sx: {
                        display: 'none',
                    },
                },
            },
        },
        muiTableBodyRowProps: ({ row }) => ({
            sx: row.depth > 0 ? {
                backgroundColor: 'action.hover',
                fontSize: '0.8rem',
                '& .MuiTableCell-root': {
                    fontSize: '0.8rem',
                    py: '6px',
                    color: 'text.secondary',
                }
            } : {}
        }),
        localization: MRT_Localization_PT_BR,
        onPaginationChange: setPagination,
        state: {
            pagination,
            isLoading: loading
        },
        rowCount: limitacaoConsumoTotal,
        manualPagination: true,
        renderTopToolbarCustomActions: () => {
            if (!buscaRealizada) return null;

            const labelMap = {
                usuario: `Trava de Usuário`,
                perfil: `Trava de Perfil`,
                cliente: `Trava de Cliente`
            };

            return (
                <Typography
                    color="primary"
                    fontWeight="bold"
                    variant="subtitle1"
                    style={{ padding: '8px 0', marginLeft: '16px' }}
                >
                    {labelMap[buscaRealizada.tipo]}
                </Typography>
            );
        }
    })

    useEffect(() => {
        setLoading(false)
    }, [])

    useEffect(() => {
        setLimitacaoConsumoPagination({
            page: pagination.pageIndex + 1,
            limit: pagination.pageSize
        });
    }, [pagination, setLimitacaoConsumoPagination]);

    useEffect(() => {
        if (usuarioSelecionado) {
            findLimitacaoConsumoUsuario();
        } else if (perfilSelecionado) {
            findLimitacaoConsumoPerfil(perfilSelecionado.IdPerfil);
        } else if (clienteSelecionado) {
            findLimitacaoConsumoCliente();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [limitacaoConsumoPagination.page, limitacaoConsumoPagination.limit]);

    return (
        loading ? <SkeletonVelesTable /> : <>
            <Typography color="primary" fontWeight="bold" variant="h6" gutterBottom>
                Limites de Consumo
            </Typography>
            <Divider style={{ margin: '16px 0', borderBottomWidth: '2px', borderBottomColor: 'rgba(0,0,0,0.5)' }} />

            <Accordion sx={{ mb: 3, borderRadius: 2, border: '1px solid', borderColor: 'info.light', boxShadow: '0 2px 6px rgba(0,0,0,0.04)' }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: 'action.hover', borderRadius: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <HelpOutlineIcon color="info" />
                        <Typography variant="subtitle1" fontWeight="bold" color="info.main">
                            💡 Guia Rápido: Como funcionam as Travas e Regras de Consumo?
                        </Typography>
                    </Box>
                </AccordionSummary>
                <AccordionDetails sx={{ pt: 1.5, pb: 2.5 }}>
                    {/* Destaques de Regra Geral */}
                    <Grid container spacing={2} alignItems="stretch" sx={{ mb: 2 }}>
                        <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
                            <Paper variant="outlined" sx={{ p: 1.5, borderColor: 'warning.light', backgroundColor: 'warning.lighter', borderRadius: 1.5, flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                <Typography variant="subtitle2" fontWeight="bold" color="warning.dark" gutterBottom>
                                    🛑 Quando a consulta é bloqueada? (Regra de Hierarquia)
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    O sistema verifica 3 níveis. Se <strong>QUALQUER UM DESSES 3</strong> atingir o limite, a consulta é travada:<br />
                                    1️⃣ <strong>Perfil do Usuário</strong> &nbsp; 2️⃣ <strong>Usuário Individual</strong> &nbsp; 3️⃣ <strong>Cliente (Empresa)</strong>
                                </Typography>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
                            <Paper variant="outlined" sx={{ p: 1.5, borderColor: 'success.light', backgroundColor: 'success.lighter', borderRadius: 1.5, flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                <Typography variant="subtitle2" fontWeight="bold" color="success.dark" gutterBottom>
                                    🏷️ O que consome o seu limite?
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    Apenas pesquisas <strong>pagas / cobradas</strong> descontam da sua trava.<br />
                                    Consultas internas, testes ou serviços isentos <strong>NÃO consomem o seu saldo</strong>.
                                </Typography>
                            </Paper>
                        </Grid>
                    </Grid>

                    <Typography variant="subtitle2" fontWeight="bold" color="text.primary" sx={{ mb: 1 }}>
                        📅 Como é calculado o período (Data Inicial e Data Final) de cada plano?
                    </Typography>

                    <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 1.5 }}>
                        <Table size="small">
                            <TableHead sx={{ backgroundColor: 'action.selected' }}>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold', width: '22%' }}>Tipo de Plano</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', width: '33%' }}>Início da Contagem (Data Inicial)</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', width: '45%' }}>Fim da Contagem (Data Final) e Renovação</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell sx={{ verticalAlign: 'top' }}>
                                        <Chip label="Pré-Pago" color="warning" size="small" sx={{ fontWeight: 'bold' }} />
                                    </TableCell>
                                    <TableCell sx={{ verticalAlign: 'top' }}>
                                        Começa na data e hora da <strong>última recarga de saldo</strong>.
                                    </TableCell>
                                    <TableCell sx={{ verticalAlign: 'top' }}>
                                        Vai até a <strong>data de expiração do pacote</strong> contratado.<br />
                                        <Typography variant="caption" color="text.secondary">
                                            <em>(Se a recarga não expirar, conta até o momento atual).</em>
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ verticalAlign: 'top' }}>
                                        <Chip label="POC (Degustação / Teste)" color="secondary" size="small" sx={{ fontWeight: 'bold', mb: 0.5 }} />
                                    </TableCell>
                                    <TableCell sx={{ verticalAlign: 'top' }}>
                                        Começa na data e hora da <strong>inclusão do plano POC</strong>.
                                    </TableCell>
                                    <TableCell sx={{ verticalAlign: 'top' }}>
                                        Vai até a <strong>data e hora atual</strong>.<br />
                                        <Typography variant="caption" color="text.secondary">
                                            <em>(Janela móvel contínua: conta o uso acumulado desde a liberação do teste até o momento atual).</em>
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ verticalAlign: 'top' }}>
                                        <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', mb: 0.5 }}>
                                            <Chip label="Pós-Pago" color="success" size="small" sx={{ fontWeight: 'bold' }} />
                                            <Chip label="Fee Mensal" color="success" size="small" sx={{ fontWeight: 'bold' }} />
                                        </Box>
                                    </TableCell>
                                    <TableCell sx={{ verticalAlign: 'top' }}>
                                        Começa sempre no <strong>dia 01 do mês atual</strong> (às 00:00).
                                    </TableCell>
                                    <TableCell sx={{ verticalAlign: 'top' }}>
                                        Vai até a <strong>data e hora atual</strong>.<br />
                                        <Typography variant="caption" color="text.secondary">
                                            <em>(Conta todo o consumo do mês corrente e renova/zera no dia 1º de cada mês).</em>
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </AccordionDetails>
            </Accordion>

            <Grid container alignItems="center" mb={2}>
                {/* Botão Adicionar (fica totalmente à esquerda) */}
                {canCreate && (
                    <Grid item xs={2}>
                        <Button
                            disabled={!clienteSelecionado}
                            variant="contained"
                            color="primary"
                            onClick={() =>
                                setOpenCreateOptions(true)
                            }
                        >
                            <AddIcon style={{ marginRight: '8px' }} /> Nova trava
                        </Button>
                    </Grid>
                )}

                {/* Container com os outros elementos, alinhados com espaçamento */}
                {/* Filtros sempre visíveis para todos os tipos de usuário */}
                <Grid item xs={canCreate ? 10 : 12}>
                    <Grid container spacing={2} justifyContent="space-between" alignItems="center">
                        <Grid item xs={3}>
                            <Autocomplete
                                fullWidth
                                autoComplete
                                includeInputInList
                                options={sortedClientes}
                                filterOptions={(options) => options}
                                value={clienteSelecionadoValido}
                                groupBy={(option) => (option.LoginCliente?.[0] || '').toUpperCase()}
                                getOptionLabel={(option) => `${option.RazaoSocial} - ${option.LoginCliente}`}
                                renderGroup={(params) => (
                                    <li key={params.key}>
                                        <GroupHeader>{params.group}</GroupHeader>
                                        <GroupItems>{params.children}</GroupItems>
                                    </li>
                                )}
                                onInputChange={(event, value, reason) => {
                                    if (reason === 'input') {
                                        debounceSearchTerm(value);
                                    }
                                }}
                                onChange={(event: any, newValue: IClienteTable | null) => {
                                    if (newValue) {
                                        if (isCliente && newValue.IdCliente !== currentUser?.IdCliente) {
                                            return
                                        }
                                        setClienteSelecionado({
                                            clienteSelecionado: {
                                                Ativo: newValue.Ativo,
                                                Atualizacao: newValue.Atualizacao,
                                                CNPJ: newValue.CNPJ,
                                                IdCliente: newValue.IdCliente,
                                                Inclusao: newValue.Inclusao,
                                                LoginCliente: newValue.LoginCliente,
                                                NomeFantasia: newValue.NomeFantasia,
                                                RazaoSocial: newValue.RazaoSocial
                                            }
                                        })
                                    } else {
                                        if (!isCliente) {
                                            resetClienteSelecionado()
                                        }
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={isCliente ? 'Cliente' : 'Selecione um cliente'}
                                        placeholder={isCliente ? undefined : 'Login, razão social, nome fantasia ou CNPJ'}
                                    />
                                )}
                            />
                        </Grid>

                        {/* Filtro de perfil, usuário e botão buscar */}
                        <>
                            <Grid item xs={3}>
                                <Autocomplete
                                    fullWidth
                                    autoComplete
                                    includeInputInList
                                    disabled={!clienteSelecionado}
                                    sx={{ opacity: clienteSelecionado ? 1 : 0.5 }}
                                    options={[...perfis].sort((a, b) => a.Descricao.localeCompare(b.Descricao))}
                                    groupBy={(option) => (option.Descricao?.[0] ?? '').toUpperCase()}
                                    getOptionLabel={(option) => option.Descricao}
                                    renderGroup={(params) => (
                                        <li key={params.key}>
                                            <GroupHeader>{params.group}</GroupHeader>
                                            <GroupItems>{params.children}</GroupItems>
                                        </li>
                                    )}
                                    value={perfilSelecionado ?? null}
                                    onChange={(_event: any, newValue: IPerfil | null) => {
                                        if (newValue) {
                                            setPerfilSelecionado({ perfilSelecionado: newValue })
                                        } else {
                                            resetPerfilSelecionado()
                                        }
                                    }}
                                    renderInput={(params) =>
                                        <TextField {...params} label="Selecione um perfil" />
                                    }
                                />
                            </Grid>

                            <Grid item xs={3}>
                                <Autocomplete
                                    fullWidth
                                    autoComplete
                                    includeInputInList
                                    disabled={!clienteSelecionado}
                                    sx={{ opacity: clienteSelecionado ? 1 : 0.5 }}
                                    options={[...usuarios].sort((a, b) =>
                                        a.LoginUsuario.localeCompare(b.LoginUsuario)
                                    )}
                                    groupBy={(option) => option.LoginUsuario[0]}
                                    getOptionLabel={(option) => option.LoginUsuario}
                                    renderGroup={(params) => (
                                        <li key={params.key}>
                                            <GroupHeader>{params.group}</GroupHeader>
                                            <GroupItems>{params.children}</GroupItems>
                                        </li>
                                    )}
                                    value={usuarioSelecionado ?? null}
                                    onChange={(_event: any, newValue: Omit<IUsuario, "Senha"> | null) => {
                                        if (newValue) {
                                            setUsuarioSelecionado({
                                                usuarioSelecionado: {
                                                    ...newValue
                                                }
                                            })
                                        } else {
                                            resetUsuarioSelecionado()
                                        }
                                    }}
                                    renderInput={(params) =>
                                        <TextField {...params} label="Selecione um usuário" />
                                    }
                                />
                            </Grid>

                            <Grid item xs={2} sx={{ textAlign: 'right' }}>
                                <Button
                                    disabled={!clienteSelecionado && !usuarioSelecionado && !perfilSelecionado}
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        if (usuarioSelecionado) {
                                            findLimitacaoConsumoUsuario()
                                            setBuscaRealizada({
                                                tipo: 'usuario',
                                                nome: usuarioSelecionado.LoginUsuario
                                            })
                                        } else if (perfilSelecionado) {
                                            findLimitacaoConsumoPerfil(perfilSelecionado.IdPerfil)
                                            setBuscaRealizada({
                                                tipo: 'perfil',
                                                nome: perfilSelecionado.Descricao
                                            })
                                        } else if (clienteSelecionado) {
                                            findLimitacaoConsumoCliente()
                                            setBuscaRealizada({
                                                tipo: 'cliente',
                                                nome: `${clienteSelecionado.RazaoSocial} - ${clienteSelecionado.LoginCliente}`
                                            })
                                        }
                                    }}
                                >
                                    <SearchIcon /> Buscar
                                </Button>
                            </Grid>
                        </>
                    </Grid>
                </Grid>
            </Grid>
            <Dialog
                open={openCreateOptions}
                onClose={() => setOpenCreateOptions(false)}
            >
                <DialogContent dividers>
                    <Button
                        disabled={!clienteSelecionado}
                        variant="contained"
                        fullWidth
                        style={{ margin: '5px 0px' }}
                        onClick={() => {
                            // Resetar o formulário antes de abrir (garantir campos zerados)
                            resetCreateLimitacaoConsumoClienteForm()
                            setCreateLimitacaoConsumoClienteOpenForm({ open: true })
                        }}
                    >
                        Criar trava para&nbsp;<strong>cliente</strong>
                    </Button>
                    <Button
                        disabled={!usuarioSelecionado}
                        variant="outlined"
                        fullWidth
                        style={{ margin: '5px 0px' }}
                        onClick={() => {
                            // Resetar o formulário antes de abrir (garantir campos zerados)
                            resetCreateLimitacaoConsumoUsuarioForm()
                            setCreateLimitacaoConsumoUsuarioOpenForm({ open: true })
                        }}
                    >
                        Criar trava para&nbsp;<strong>usuário</strong>
                    </Button>
                    <Button
                        disabled={!perfilSelecionado}
                        variant="outlined"
                        fullWidth
                        style={{ margin: '5px 0px' }}
                        onClick={() => {
                            setOpenCreateOptions(false)
                            setCreateLimitacaoConsumoPerfilOpenForm({ open: true, IdPerfil: perfilSelecionado?.IdPerfil })
                        }}
                    >
                        Criar trava para&nbsp;<strong>perfil</strong>
                    </Button>
                </DialogContent>
            </Dialog>

            <ModalTiposConsumo
                selectedGroup={selectedGroup}
                open={Boolean(selectedGroup)}
                onClose={() => setSelectedGroup(null)}
            />


            <MaterialReactTable table={table} />
        </>
    )
}